var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin"},[_c('reset-password-form',{attrs:{"submit":_vm.resetPassword,"email":_vm.email}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }